import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'UIComponents/elements/headings';
import LimitUsageFeatureRow from './LimitUsageFeatureRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LimitUsageSection = ({
  limitUsages,
  width = '60%'
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-0",
    style: {
      maxWidth: '90%',
      width
    },
    children: [/*#__PURE__*/_jsx(H5, {
      className: "m-bottom-5",
      "aria-level": 3,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ebxInterstitialPage.LimitUsageSection.header"
      })
    }), limitUsages.map(limitUsage => /*#__PURE__*/_jsx(LimitUsageFeatureRow, {
      limitUsage: limitUsage
    }, limitUsage.limitName))]
  });
};
export default LimitUsageSection;